const values = [
  { word: "Compassion", note: "We meet pain with presence." },
  { word: "Service", note: "We lead with our hands." },
  { word: "Family", note: "The unit we protect and uplift." },
  { word: "Community", note: "No one walks alone." },
  { word: "Legacy", note: "Honoring those who came before." },
  { word: "Faith", note: "The quiet strength behind it all." },
];

export default function CoreValues() {
  return (
    <section data-testid="values-section" className="bg-[#F4F1EB]">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 py-24 sm:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="text-xs tracking-[0.22em] uppercase font-bold text-[#8B2635] mb-4">
              Core Values
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl text-[#2C2A29] leading-[1.05] tracking-tight">
              Six words.
              <br />
              <span className="italic text-[#692128]">One way of being.</span>
            </h2>
            <p className="mt-6 text-[#5C5856] text-lg leading-relaxed">
              These are not slogans. They are the standards we live by — every conversation,
              every visit, every program.
            </p>
          </div>

          <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-3 gap-px bg-[#D5C9B3] rounded-3xl overflow-hidden border border-[#D5C9B3]">
            {values.map((v) => (
              <div
                key={v.word}
                data-testid={`value-${v.word.toLowerCase()}`}
                className="bg-[#FAF8F5] p-7 md:p-9 hover:bg-[#F4F1EB] transition-colors min-h-[180px] flex flex-col justify-between"
              >
                <div className="font-serif text-3xl md:text-4xl text-[#2C2A29]">{v.word}</div>
                <div className="text-sm text-[#5C5856] mt-6 leading-snug">{v.note}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
